import styled from 'styled-components';

export const SFormContainer = styled.div`
  height: 350px;
`;
